export * from './webStorage';
export * from './localStorage';
export * from './sessionStorage';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ngx-webstorage/dist/services/index.js
// module id = ../../../../ngx-webstorage/dist/services/index.js
// module chunks = 18